import { render, staticRenderFns } from "./singlehome.vue?vue&type=template&id=8ca5edd6&scoped=true&"
import script from "./singlehome.vue?vue&type=script&lang=js&"
export * from "./singlehome.vue?vue&type=script&lang=js&"
import style0 from "./singlehome.vue?vue&type=style&index=0&id=8ca5edd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca5edd6",
  null
  
)

export default component.exports